// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__3b0eN","option":"styles_option__2XOnN"};